<template>
  <HeaderDashboardCards
    data-testid="roles-header-dashboard"
    aria-label="Roles summary"
    :metrics="cards"
    variant="count-only"
    :columns="5"
    :action-label="activeIndicator ? 'Clear Filter' : 'Apply Filter'"
    @select="handleSelect"
  />
</template>

<script setup>
import { computed } from "vue";
import HeaderDashboardCards from "@components/HeaderDashboardCards/HeaderDashboardCards.vue";

const props = defineProps({
  activeCount: {
    type: Number,
    default: 0,
  },
  draftCount: {
    type: Number,
    default: 0,
  },
  invalidCount: {
    type: Number,
    default: 0,
  },
  noPositionAttachedCount: {
    type: Number,
    default: 0,
  },
  notUsedCount: {
    type: Number,
    default: 0,
  },
  /**
   * Key of the card whose filter is currently applied to the list
   * ('active' | 'draft' | 'invalid' | 'no-position-attached' | 'not-used').
   * Used for the pressed state only; clicking an active card again resets
   * to the default filter state.
   */
  activeIndicator: {
    type: String,
    default: null,
    validator: (v) =>
      v === null ||
      ["active", "draft", "invalid", "no-position-attached", "not-used"].includes(v),
  },
});

const emit = defineEmits(["select-indicator"]);

const cards = computed(() => [
  {
    key: "active",
    title: "Active",
    count: props.activeCount,
    isRed: props.activeCount === 0,
    clickable: true,
    active: props.activeIndicator === "active",
  },
  {
    key: "draft",
    title: "Draft",
    count: props.draftCount,
    isRed: false,
    clickable: true,
    active: props.activeIndicator === "draft",
  },
  {
    key: "invalid",
    title: "Invalid",
    count: props.invalidCount,
    isRed: props.invalidCount > 0,
    clickable: true,
    active: props.activeIndicator === "invalid",
  },
  {
    key: "no-position-attached",
    title: "No position attached",
    count: props.noPositionAttachedCount,
    isRed: props.noPositionAttachedCount > 0,
    clickable: true,
    active: props.activeIndicator === "no-position-attached",
  },
  {
    key: "not-used",
    title: "Not used",
    count: props.notUsedCount,
    isRed: props.notUsedCount > 0,
    clickable: true,
    active: props.activeIndicator === "not-used",
  },
]);

function handleSelect(key) {
  emit("select-indicator", key);
}
</script>
